import { InjectionToken } from '@angular/core';

import { A11yLabelTarget } from '../interfaces/a11y.interfaces';

export const KH_A11Y_TARGET = new InjectionToken<A11yLabelTarget>('KhA11yTarget');
